import { StoreUserState } from '@/types';

export default {
  user: (state: StoreUserState) => state.loggedUser,
  userPermissionGroups: (state: StoreUserState) =>
    state.loggedUser?.signInUserSession?.accessToken?.payload['cognito:groups'] || [],
};
